import styled from 'styled-components'

type DotButtonProps = {
  isActive: boolean | undefined
}

export const DotButton = styled.button<DotButtonProps>`
  flex-shrink: 0;
  padding: 0;
  border: 0;
  transition: background 0.2s ease;
  cursor: pointer;

  ${({ theme }) => `
    width: ${theme.space.mobile.tiny};
    height: ${theme.space.mobile.tiny};
    border-radius: ${theme.borderRadius.small};
    background: ${theme.color.cornflower};
    margin: 0 ${theme.space.mobile.nano};
  `}

  ${({ theme, isActive }) =>
    isActive &&
    `
    background: ${theme.color.white};
    cursor: default;
  `}

  &:focus {
    outline: 0;
  }
`
